export class RatesProviderStore {
  constructor() {
    this.snapshot = {};
  }

  setSnapshot(snapshot) {
    this.snapshot = snapshot;
  }

  /**
   *
   * @returns {GlobalState}
   */
  getSnapshot() {
    return this.snapshot;
  }
}

export const RatesProviderStoreInstance = new RatesProviderStore();
